// Special search entries injected into the directions dropdowns. They are not real locations -
// picking one resolves to an actual location id through GET /app/directions/nearest.
// `value` is the sentinel held in form state, `type` is what the API expects.
// Declaration order is the order they are listed in the dropdown.
const NearestSearchOptions = [
	{
		label: 'Nearest Lift',
		value: 'nearest_lift',
		search_key: 'Nearest Lift',
		type: 'lift'
	},
	{
		label: 'Nearest Male Toilet',
		value: 'nearest_male_toilet',
		search_key: 'Nearest Male Toilet',
		type: 'toilet_male'
	},
	{
		label: 'Nearest Female Toilet',
		value: 'nearest_female_toilet',
		search_key: 'Nearest Female Toilet',
		type: 'toilet_female'
	},
	{
		label: 'Nearest Accessible Toilet',
		value: 'nearest_disabled_toilet',
		search_key: 'Nearest Accessible Toilet',
		type: 'toilet_disabled'
	}
];

export const isNearestSearchOption = value => NearestSearchOptions.some(option => option.value === value);

export const getNearestSearchOption = value => NearestSearchOptions.find(option => option.value === value);

// -1 for anything that is not a special search, so real locations always sort after them
export const getNearestSearchOptionIndex = value => NearestSearchOptions.findIndex(option => option.value === value);

export default NearestSearchOptions;
